module.exports = __webpack_public_path__ + "65a43416a613e9f9746e50e4a9a3df81.png";